export const baseURL = "https://greedylionpro.ajobfun.cloud/";
export const adminBaseURL = "https://admin.ajobfun.cloud/";
export const key = "BS67Rfb0Tf";